import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { deleteCampaign } from "../../services/notification";
import { formattedDate } from "../../components/formatted/FormattedDateAndTime";

const CampaignDeleteModal = ({
  campaign,
  campaignDelete,
  setCampaignDelete,
  fetchCampaignsPeriods,
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggle = () => {
    if (!isSubmitting) {
      setCampaignDelete(false);
    }
  };

  const startDate = formattedDate(campaign.start, t, true, false, true);
  const endDate = formattedDate(campaign.stop, t, true, false, true);

  const handleDelete = async () => {
    if (!campaign?._id || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      const res = await deleteCampaign(campaign._id);
      if (res.status === 200) {
        await fetchCampaignsPeriods();
        setCampaignDelete(false);
      }
    } catch (error) {
      console.error("Error deleting campaign:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={campaignDelete}
      toggle={toggle}
      centered
      contentClassName="rounded-lg char-modal-content campaign-cancel-modal"
      style={{ maxWidth: "600px", width: "600px" }}
    >
      <ModalHeader className="char-modal-header">
        <span className="char-modal-header-title">
          {t("campaign.deleteCampaign")}
        </span>
        <button
          type="button"
          onClick={toggle}
          className="char-modal-header-close"
          aria-label={t("Close")}
          disabled={isSubmitting}
        >
          <i className="fas fa-times char-modal-header-close-icon" />
        </button>
      </ModalHeader>
      <ModalBody className="campaign-cancel-modal__body">
        <p className="campaign-cancel-modal__intro">
          {t("campaign.deleteModalQuestion")}
        </p>
        <p className="campaign-cancel-modal__intro">
          {t("campaign.deleteModalPeriod", { startDate, endDate })}
        </p>
        <p className="campaign-cancel-modal__intro">
          {t("campaign.deleteModalWarning")}
        </p>
        <ul className="campaign-cancel-modal__list">
          <li>{t("campaign.deleteModalBullet1")}</li>
          <li>{t("campaign.deleteModalBullet2")}</li>
          <li>{t("campaign.deleteModalBullet3")}</li>
        </ul>
      </ModalBody>
      <ModalFooter className="char-modal-footer campaign-cancel-modal__footer">
        <button
          type="button"
          className="modal-button modal-button-cancel"
          onClick={toggle}
          disabled={isSubmitting}
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          className={`modal-button modal-button-save ${isSubmitting ? "disabled" : ""}`}
          onClick={handleDelete}
          disabled={isSubmitting}
        >
          {isSubmitting ? t("Saving...") : t("campaign.deleteCampaign")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CampaignDeleteModal;
